var _ellipse, _path, _g, _g2, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoAlertIllustration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 106,
    viewBox: "0 0 109 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 51.1937,
    cy: 95.4602,
    rx: 10.5209,
    ry: 10.5398,
    fill: "#9EBCFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.4946 0C56.6256 0.000169698 60.7847 4.16742 60.7847 9.30762C60.7845 14.4476 56.6254 18.6141 51.4946 18.6143C46.3637 18.6143 42.2038 14.4477 42.2036 9.30762C42.2036 4.16732 46.3636 0 51.4946 0ZM51.2368 5.1709C48.814 5.17097 46.8503 7.02227 46.8501 9.30664C46.8501 11.5912 48.8139 13.4433 51.2368 13.4434C53.6598 13.4434 55.6245 11.5912 55.6245 9.30664C55.6243 7.02223 53.6597 5.1709 51.2368 5.1709Z",
    fill: "#9EBCFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_7781_16555)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.4932 11.8926C70.8771 11.8926 86.5916 27.6063 86.5918 46.9902V73.9268C86.5918 75.6176 87.9625 76.9883 89.6533 76.9883C94.8089 76.9883 98.988 81.1678 98.9883 86.3232C98.9883 91.4789 94.809 95.6591 89.6533 95.6592H13.335C8.17937 95.659 4 91.4789 4 86.3232C4.00024 81.1678 8.17953 76.9884 13.335 76.9883C15.0253 76.9883 16.3955 75.618 16.3955 73.9277V46.9902C16.3957 27.6065 32.1094 11.8928 51.4932 11.8926Z",
    fill: "url(#paint0_linear_7781_16555)"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    x: 57.7139,
    y: 2.25293,
    width: 51.2861,
    height: 53.3638
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(2px)",
      clipPath: "url(#bgblur_0_7781_16555_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_7781_16555)",
    "data-figma-bg-blur-radius": 4
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 83.3568,
    cy: 27.9348,
    rx: 21.6429,
    ry: 21.6819,
    fill: "url(#paint1_linear_7781_16555)",
    fillOpacity: 0.71,
    shapeRendering: "crispEdges"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0679 17.8008C91.0086 16.8584 92.5344 16.8584 93.4751 17.8008C94.4154 18.7431 94.4153 20.2705 93.4751 21.2129L86.7651 27.9346L93.4741 34.6562C94.4146 35.5987 94.4148 37.127 93.4741 38.0693C92.5334 39.0116 91.0076 39.0116 90.0669 38.0693L83.3579 31.3477L76.6499 38.0693C75.7092 39.0117 74.1834 39.0116 73.2427 38.0693C72.302 37.127 72.3021 35.5987 73.2427 34.6562L79.9507 27.9346L73.2417 21.2129C72.3014 20.2705 72.3013 18.7431 73.2417 17.8008C74.1824 16.8584 75.7082 16.8584 76.6489 17.8008L83.3579 24.5215L90.0679 17.8008Z",
    fill: "#4C95FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 86.1254C4 81.136 8.04471 77.0913 13.0341 77.0913H89.9544C94.9438 77.0913 98.9885 81.136 98.9885 86.1254H4Z",
    fill: "url(#paint2_linear_7781_16555)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_7781_16555",
    x: 0,
    y: 7.89258,
    width: 102.988,
    height: 91.7666,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7781_16555"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7781_16555",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_7781_16555",
    x: 57.7139,
    y: 2.25293,
    width: 51.2861,
    height: 53.3638,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7781_16555"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7781_16555",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_7781_16555_clip_path",
    transform: "translate(-57.7139 -2.25293)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 83.3568,
    cy: 27.9348,
    rx: 21.6429,
    ry: 21.6819
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7781_16555",
    x1: 51.4948,
    y1: 11.8926,
    x2: 51.4948,
    y2: 95.6586,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDEBF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2E9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7781_16555",
    x1: 61.7139,
    y1: 24.3211,
    x2: 107.719,
    y2: 38.4282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFBF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7781_16555",
    x1: 51.4942,
    y1: 80.3764,
    x2: 9.41319,
    y2: 80.8165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7FCFF",
    stopOpacity: 0.14
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoAlertIllustration);
export default __webpack_public_path__ + "static/media/noAlertIllustration.da8f5860e76c9d56869b230171c51a25.svg";
export { ForwardRef as ReactComponent };